import { Action } from "redux";

export const GEOCALC_GEOMETRY_REQUESTED = "GEOCALC_GEOMETRY_REQUESTED";

export interface RequestGeoCalcGeometryAction extends Action {
    calculationId: string;
}

export const requestGeoCalcGeometryAction = (calculationId: string): RequestGeoCalcGeometryAction => {
    return {
        type: GEOCALC_GEOMETRY_REQUESTED,
        calculationId: calculationId,
    };
};
